// extracted by mini-css-extract-plugin
export default {"container":"TopicsIndicators_container__3WGfm"};